<template>
    <div class="w-100" id="tableEditarMultipleAcuerdosClientesBase">
      <ui-modal
        ref="modal"
        title="Editar Acuerdo Cliente"
        class="modal-editar-simple-acuerdo-linea w-100"
        @close="actionSetVisibleModalEditarSimpleAcuerdoLinea(false); ActionSetZindexTablaModal(false)"
      >
  
        <div class="w-100" id="editarMultipleAcuerdoLineasModal">
          <data-table-acuerdos-clientes
            :custom-headers="true"
            :headers="headers"
            :data="dataAux"
            idtabla="listado_confirmar_seleccionados1"
            :formulario="true"
            :acciones="[]"
            :load="load"
            :filtroColdtreatment="filtroColdtreatment"
          />
        </div>
        <!-- Footer -->
        <div class="d-flex justify-content-between mt-2">
          <button class="btn btn-default" @click="closeModal('modal');">
            Cerrar
          </button>
          <button class="btn btn-outline-warning" @click="editar()" id="buttonRefEditarAcuerdoLineas112">
            Actualizar
          </button>
        </div>
      </ui-modal>
    </div>
  </template>
  
  <script>
  // Common
  import { mapActions, mapState } from "vuex";
  import { getAcuerdosClientesBaseByIds, editarAcuerdoBaseClientes } from "@/constants/lineas";
  import DataTableAcuerdosClientes from "../../../../dataTables/tarifas/DataTableAcuerdosClientes";
  
  export default {
    
    props:["data","load","dataAux","limpiarChecks","getListaAcuerdosClientes","filtroColdtreatment"],
  
    data() {
      return {
        headers:[
          { title: "N°", width: "40px" },
          { title: "Cliente", width: "40px" },
          { title: "Naviera", width: "40px" },
          { title: "Naviera Salida", width: "40px" },
          { title: "POL", width: "50px" },
          { title: "POD", width: "30px" },
          { title: "Desde", width: "100px" },
          { title: "Hasta", width: "100px" },
          { title: "Vigencia", width: "100px" },
          { title: "TT", width: "10px" },
          { title: "Pública (Venta)", width: "10px" },
          { title: "Neta Cte Base", width: "10px" },
          { title: "Margen Com.", width: "10px" },
          { title: "Neta Cte.", width: "10px" },
          { title: "Descuento", width: "10px" },
          { title: "Unidad", width: "10px" },
          { title: "Commodity", width: "90px" },
          { title: "Atmósfera", width: "35px" },
          { title: "Trat. frío", width: "35px" },
          { title: "Dias Libres Origen", width: "10px" },
          { title: "Dias Plug Origen", width: "10px" },
          { title: "Dias Libres Destino", width: "10px" },
          { title: "Dias Plug Destino", width: "10px" },
          { title: "Genset", width: "2px" },
          { title: "Get Out", width: "2px" },
          { title: "Comentarios", width: "240px" },
          { title: "Tipo Contrato", width: "70px" },
          { title: "Contrato - Número", width: "70px" },
        ],
      };
    },
    methods: {
      ...mapActions(["ActionsSetShowModalAcuerdoLineasClienteBase"]),
      ...mapActions("lineas", ["actionSetVisibleModalEditarSimpleAcuerdoLinea","actionSetDataListarTarifasAcuerdosClientesBase"]),
      ...mapActions(["ActionSetZindexTablaModal"]),
      estadoButton(text, estado = true) {
        let buttonRef = document.querySelector("#buttonRefEditarAcuerdoLineas112");
        buttonRef.innerHTML = text;
        buttonRef.disabled = estado;
      },
      async editar() {

        this.dataAux.forEach(element => {
          const {
            cliente_id, naviera, pod, pol, from_date,
            to_date, vigencia, commercial_margin, container_id, products_category_id,
            atmosphere_id, comment
          } = element;

          if (cliente_id.id === undefined || cliente_id.id === "") {
            return this.$vToastify.error(
              "Campo Cliente requerido",
              "¡Error!"
            );
          }

          if (naviera.id === undefined || naviera.id === "") {
            return this.$vToastify.error(
              "Campo Naviera requerido",
              "¡Error!"
            );
          }

          if (pod.id === undefined || pod.id === "") {
            return this.$vToastify.error(
              "Campo POD requerido",
              "¡Error!"
            );
          }

          if (pol.id === undefined || pol.id === "") {
            return this.$vToastify.error(
              "Campo POL requerido",
              "¡Error!"
            );
          }

          if (from_date === undefined || from_date === "") {
            return this.$vToastify.error(
              "Campo Desde requerido",
              "¡Error!"
            );
          }

          if (to_date === undefined || to_date === "") {
            return this.$vToastify.error(
              "Campo Hasta requerido",
              "¡Error!"
            );
          }

          if (vigencia === undefined || vigencia === "") {
            return this.$vToastify.error(
              "Campo Vigencia requerido",
              "¡Error!"
            );
          }

          if (commercial_margin === undefined || commercial_margin === "") {
            return this.$vToastify.error(
              "Campo Margen Com. requerido",
              "¡Error!"
            );
          }

          if (container_id.id === undefined || container_id.id === "") {
            return this.$vToastify.error(
              "Campo Unidad requerido",
              "¡Error!"
            );
          }

          if (products_category_id.id === undefined || products_category_id.id === "") {
            return this.$vToastify.error(
              "Campo Commodity requerido",
              "¡Error!"
            );
          }

          if (atmosphere_id.id === undefined || atmosphere_id.id === "") {
            return this.$vToastify.error(
              "Campo Atmósfera requerido",
              "¡Error!"
            );
          }

          if (comment === undefined || comment === "") {
            return this.$vToastify.error(
              "Campo Margen requerido",
              "¡Error!"
            );
          }

        });

        const form = {
          tariff_clients: this.dataAux.map(cl => {
            const {
              id, cliente_id, naviera, pod, pol, from_date,
              to_date, vigencia, margin, commercial_margin, container_id, products_category_id,
              atmosphere_id, coldtreatment, genset, comment
            } = cl;

            return {
              id,
              cliente_id: cliente_id.id,
              naviera: naviera.id,
              pod: pod.id,
              pol: pol.id,
              from_date,
              to_date,
              vigencia,
              margin,
              commercial_margin,
              container_id: container_id.id,
              products_category_id: products_category_id.id,
              atmosphere_id: atmosphere_id.id,
              coldtreatment: typeof coldtreatment === "object" ? (coldtreatment.name || "") : (coldtreatment || ""),
              genset,
              comment
            };
          })
        };

        this.estadoButton("Actualizando...");
        this.$vToastify.loader("Realizando Solicitud...");

        try {
          await editarAcuerdoBaseClientes(form);

          this.$vToastify.stopLoader();
          this.estadoButton("Actualizar", false);
          await this.getListaAcuerdosClientes();

          this.limpiarChecks();
          this.closeModal("modal");
          this.$vToastify.success(
            "Acuerdo de Cliente Bases seleccionados actualizados correctamente",
            "¡Realizado!"
          );

        } catch (error) {

          this.$vToastify.stopLoader();
          this.estadoButton("Actualizar", false);
          return this.$vToastify.error(
            "Error al editar acuerdos clientes base, intente más tarde.",
            "¡Error!"
          );

        }
      },
      async editarMultiple() {

        if (this.ids.length === 0) return this.$vToastify.warning(
          "Debe seleccionar registros para editar.",
          "!Precaución¡"
        );

        this.openModal("modal");

        try {
          const { data_table } = await getAcuerdosClientesBaseByIds(this.ids);

          this.dataAux = data_table.map(al => ({
                id: al.data_complementaria.id,
                cliente_id: {
                  id: al.data_complementaria.cliente_id.id,
                  name: al.data_complementaria.cliente_id.name
                },
                naviera: {
                  id: al.data_complementaria.naviera_id.id,
                  name: al.data_complementaria.naviera_id.name
                },
                naviera_salida: al.data[2],
                pod: {
                  id: al.data_complementaria.pod.id,
                  name: al.data_complementaria.pod.name
                },
                pol: {
                  id: al.data_complementaria.pol.id,
                  name: al.data_complementaria.pol.name
                },
                margin: al.data_complementaria.margin,
                commercial_margin: al.data_complementaria.commercial_margin,
                neta_cliente: al.data_complementaria.neta_cliente,
                from_date: al.data_complementaria.from_date,
                to_date: al.data_complementaria.to_date,
                transit_time: al.data_complementaria.transit_time,
                neta: al.data_complementaria.neta,
                public_value: al.data_complementaria.public_value,
                vigencia: al.data_complementaria.vigencia,
                container_id: {
                  id: al.data_complementaria.container_id.id,
                  name: al.data_complementaria.container_id.name
                },
                products_category_id: {
                  id: al.data_complementaria.products_category_id.id,
                  name: al.data_complementaria.products_category_id.name
                },
                descuento: parseInt(al.data_complementaria.public_value) - parseInt(al.data_complementaria.neta),
                atmosphere_id: al.data_complementaria.atmosphere_id,
                coldtreatment: al.data_complementaria.coldtreatment && al.data_complementaria.coldtreatment !== "-"
                  ? {
                      id: al.data_complementaria.coldtreatment_id || "",
                      name: al.data_complementaria.coldtreatment
                    }
                  : { id: "", name: "" },
                free_days_embark: al.data_complementaria.free_days_embark,
                plug_days_embark: al.data_complementaria.plug_days_embark,
                free_days_land: al.data_complementaria.free_days_land,
                plug_days_land: al.data_complementaria.plug_days_land,
                genset: al.data_complementaria.genset === "Si",
                get_out: al.data_complementaria.get_out,
                comment: al.data_complementaria.comment,
                tipo_contrato_id: {
                  id: al.data_complementaria.tipo_contrato.id,
                  name: al.data_complementaria.tipo_contrato.name
                },
                tariff_contract_id: {
                  id: al.data_complementaria.tariff_contract_id,
                  name: al.data_complementaria.tariff_contract_name
                }
              }
            )
          );

        } catch (error) {

          return this.$vToastify.error(
            "Error al obtener registros, recargue la página y vuelva a intentar",
            "¡Error!"
          );

        }
      },
      openModal(ref) {
        this.ActionSetZindexTablaModal(true);
        this.$refs[ref].open();
      },
      closeModal(ref) {
        this.$refs[ref].close();
      },
  
    },
    computed: {
      ...mapState(["showAcuerdoLineasClienteBase"]),
      ...mapState("lineas", ["visibleModalEditarSimpleAcuerdoLinea"]),
      
    },
    components: {
        DataTableAcuerdosClientes
    },
    watch: {
      visibleModalEditarSimpleAcuerdoLinea: function (_new) {
        (_new) && this.openModal("modal");
        
      },
    },
  };
  </script>
  
  <style>
  #tableEditarMultipleAcuerdosClientesBase .ui-modal__container{
    width: 100%;
  }
  </style>
  